import { render, staticRenderFns } from "./RunningTradeTab.vue?vue&type=template&id=50df7e8a"
import script from "./RunningTradeTab.vue?vue&type=script&lang=js"
export * from "./RunningTradeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports